import { RouterProvider } from 'react-router/dom';

// project import
import router from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { AuthProvider } from 'contexts/AuthContext';
import { BrandingProvider } from 'contexts/BrandingContext';
import { FeaturesProvider } from 'contexts/FeaturesContext';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
  <BrandingProvider>
    <ThemeCustomization>
      <AuthProvider>
        <FeaturesProvider>
          <ScrollTop>
            <RouterProvider router={router} />
          </ScrollTop>
        </FeaturesProvider>
      </AuthProvider>
    </ThemeCustomization>
  </BrandingProvider>
);

export default App;
